/**
 * Safely maps over an array, applying a transformation function to each element.
 * If the input array is `null` or `undefined`, returns an empty array instead of throwing an error.
 *
 * @typeParam T - The type of elements in the input array.
 * @typeParam U - The type of elements in the resulting array after mapping.
 * @param arr - The array to map over, which may be `null` or `undefined`.
 * @param fn - The mapping function to apply to each element and its index.
 * @returns A new array containing the results of applying `fn` to each element of `arr`, or an empty array if `arr` is `null` or `undefined`.
 */
/**
 * Estende safeMap per restituire almeno un elemento creato tramite fn(undefined, 0)
 * se l'array è nullo/vuoto e ensureAtLeastOne è true.
 *
 * @param arr - L'array da mappare, può essere nullo o undefined.
 * @param fn - Funzione di mapping.
 * @param ensureAtLeastOne - Se true, ritorna almeno un elemento creato con fn(undefined, 0) se arr è nullo/vuoto.
 */
export const safeMap = <T, U>(
  arr: T[] | null | undefined,
  fn: (item: T, i: number) => U,
  ensureAtLeastOne = false
): U[] => {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr.map(fn);
  }
  if (ensureAtLeastOne) {
    return [fn({} as T, 0)];
  }
  return [];
};
